// extracted by mini-css-extract-plugin
export default {"header":"TeacherPeopleView_header__KxpNA","backBtn":"TeacherPeopleView_backBtn__fhJuj","search":"TeacherPeopleView_search__jd5hR"};